import { Slot, User } from '@allara-health/source-health-client'

/**
 * Enhanced provider type that includes availability information
 */
export type EnhancedProvider = User & {
  noPenaltySlots: Slot[]
  mediumPenaltySlots: Slot[]
  highPenaltySlots: Slot[]
}

export enum ProviderTagType {
  SPECIALTY = 'SPECIALTY',
  CARE_EXPERTISE = 'CARE_EXPERTISE',
}

export const PENALTY_SCORE_MAP = {
  no_penalty: 0,
  medium_penalty: 0.5,
  high_penalty: 1,
}

export type ProviderTag = {
  id: string
  type: ProviderTagType
  text: string
}

export type ProviderTags = {
  provider_id: string
  tags: ProviderTag[]
}

export type TagMapping = {
  tag_id: string
  tag_text: string
  tag_type: ProviderTagType
  priority: number
}

export type ConditionTagMapping = {
  condition_code: string
  condition_display_name: string
  condition_provider_match_description: string
  tag_mappings: TagMapping[]
}
